// Public-site configuration — the handful of values on the marketing landing page
// that are a human decision rather than a description of what the code does.
// Same idea as ./legal.js, kept separate because these change on a different clock.
//
// ⚠️ CONFIRM BEFORE DEPLOY:
//   APP_DOWNLOAD_URL — where "Get the iOS app" should point.
//
// Leave APP_DOWNLOAD_URL as null until there is a real link. The landing page hides
// the download button entirely when it is null, which is the honest thing to render:
// a dead App Store badge on a public page is worse than no badge, and App Review will
// follow every link on the page it is given as the marketing URL.
//
// During the TestFlight phase, set this to the public TestFlight invite link.
// After the App Store / unlisted listing goes live, swap it for that URL.
// See ../../../listful-api/docs/LAUNCH_READINESS.md §1.

export const APP_DOWNLOAD_URL = null;

// What the download button says. TestFlight links deserve the caveat; an App Store
// link does not. Only shown when APP_DOWNLOAD_URL is set.
export const APP_DOWNLOAD_LABEL = 'Get the iOS app';
export const APP_DOWNLOAD_NOTE = null; // e.g. 'Beta via TestFlight'

// The minimum age for holding an account. Stated on the landing page and in the
// privacy policy, and it drives the App Store age-rating answers. Children younger
// than this belong on a parent's account as a managed list owner, not as users of
// their own — see LAUNCH_READINESS.md §7.1.
export const MINIMUM_AGE = 13;
